import {call, put, all, takeLatest} from "redux-saga/effects";
import {Api} from "../api";
import * as mediaActions from "../actions/media";
import * as authActions from "../actions/auth";
import {saveAs} from "file-saver";


function* uploadMedia(action) {
  try {
    const res = yield call(Api.media.uploadMedia, action.payload);
    yield put({type: mediaActions.UPLOAD_MEDIA_SUCCESS, payload: res.data});
    if(action.callback) action.callback(res.data);
  } catch (err) {
    yield put({type: mediaActions.UPLOAD_MEDIA_FAIL, payload: {error: err.response?.data?.message || 'An error occurred'}});
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

function* uploadMediaAll(action) {
  try {
    const files = [...action.payload.body];
    const res = yield all(files.map(file => {
      const formData = new FormData();
      formData.append("file", file);
      const payload = {body: formData, bucket: action.payload.bucket, token: action.payload.token}
      return call(Api.media.uploadMedia, payload)
    }));
    const data = res.map((item, i) => ({
      Id: 0,
      MediaName: files[i].name,
      Size: files[i].size,
      MediaReferenceId: item.data.id,
      TableName: action.payload.addFields.TableName,
      ObjectId: action.payload.addFields.ObjectId,
      FieldName: action.payload.addFields.FieldName,
      Remarks: null,
    }));
    if(action.callback) action.callback(data);
    yield put({type: mediaActions.UPLOAD_MEDIA_ALL_SUCCESS, payload: res});
  } catch (err) {
    yield put({type: mediaActions.UPLOAD_MEDIA_ALL_FAIL, payload: {error: err.response?.data?.message || 'An error occurred'}});
  }
}

function* downloadMedia(action) {
  try {
    const res = yield call(Api.media.downloadMedia, action.payload);
    const blob = new Blob([res.data], { type: res.data.type });
    saveAs(blob, action.payload.file.MediaName);
    yield put({ type: mediaActions.DOWNLOAD_MEDIA_SUCCESS, payload: action.payload });
  } catch (err) {
    yield put({type: mediaActions.DOWNLOAD_MEDIA_FAIL, payload: {error: err.response?.data?.message || 'An error occurred'}});
    if (err?.response?.status === 401) yield put({ type: authActions.AUTH_LOGOUT_REQUEST });
  }
}

export default all([
  takeLatest(mediaActions.UPLOAD_MEDIA_REQUEST, uploadMedia),
  takeLatest(mediaActions.UPLOAD_MEDIA_ALL_REQUEST, uploadMediaAll),
  takeLatest(mediaActions.DOWNLOAD_MEDIA_REQUEST, downloadMedia),
]);
